// Base 8 diagnostic questions (12 questions across 5 spheres)
// Theme: Power, material success, money, ambition, efficiency vs control
const base8 = [
    // ── I Sfera: Bendroji energija ir savimoka — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai keliu sau tikslą ir matau galimybę pasiekti daugiau:',
      choices: {
        a: 'Drąsiai imuosi veiksmų, planuoju strategiškai ir tikiu, kad gebu pasiekti didelius rezultatus.',
        b: 'Arba persistengiu ir negailiu savęs, kol perdegu, arba bijau galios ir net nebandau siekti daugiau.',
        c: 'Užsibrėžiu tikslą, bet judu atsargiai, kad pernelyg nerizikuočiau ir neperspausčiau savęs.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Kai situacija reikalauja perimti kontrolę ir priimti atsakomybę:',
      choices: {
        a: 'Natūraliai imuosi vairo, priimu sprendimus ir vedu kitus link bendro rezultato.',
        b: 'Arba viską noriu kontroliuoti pats ir niekuo nepasitikiu, arba visai vengiu atsakomybės dėl baimės suklysti.',
        c: 'Atsakomybę prisiimu tik tada, kai nematau kito kelio, ir stengiuosi dalintis ja su kitais.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Kai galvoju apie galią ir įtaką savo gyvenime:',
      choices: {
        a: 'Galią matau kaip įrankį kurti gera – naudoju ją atsakingai ir nesijaučiu dėl jos kaltas.',
        b: 'Arba galios siekiu, kad įrodyčiau savo vertę, arba jos bijau ir slepiuosi nuo dėmesio bei lyderystės.',
        c: 'Įtakos siekiu saikingai, tik tiek, kiek reikia man rūpimiems dalykams apsaugoti.',
      },
    },
    // ── II Sfera: Darbas ir karjera — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Kai darbe atsiveria galimybė kilti, vadovauti ar imtis didelio projekto:',
      choices: {
        a: 'Drąsiai priimu iššūkį, nes tikiu savo gebėjimu organizuoti ir pasiekti rezultatą.',
        b: 'Arba griebiuosi visko ir persidirbu iki išsekimo, arba atsisakau iš baimės, kad nepavyks.',
        c: 'Apsvarstau, ar verta, ir imuosi tik tada, kai esu tikras, kad suvaldysiu apkrovą.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Kai dirbu su komanda siekdamas bendro tikslo:',
      choices: {
        a: 'Moku deleguoti, motyvuoti ir vesti kitus, neprarasdamas bendros vizijos.',
        b: 'Arba viską perimu pats, nes manau, kad tik aš padarysiu gerai, arba nedrįstu vadovauti.',
        c: 'Prisidedu prie organizavimo, bet vengiu prisiimti pernelyg didelę atsakomybę už visus.',
      },
    },
    // ── III Sfera: Santykiai ir partnerystė — 2 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Kai artimuose santykiuose kyla klausimas, kas priima sprendimus:',
      choices: {
        a: 'Siekiu lygiavertės partnerystės, kur galia ir atsakomybė pasidalijamos pagarbiai.',
        b: 'Arba bandau dominuoti ir viską kontroliuoti, arba visai atiduodu vairą kitam ir prarandu save.',
        c: 'Stengiuosi derėtis dėl pusiausvyros, bet kartais nusileidžiu vien dėl šventos ramybės.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Kai galvoju apie tai, ką noriu duoti ir gauti artimuose santykiuose:',
      choices: {
        a: 'Noriu būti tvirta atrama ir partneriu, kuriuo galima pasitikėti ir kuris gerbia kito jėgą.',
        b: 'Arba matuoju santykius pasiekimais ir statusu, arba bijau, kad nesu pakankamai vertingas.',
        c: 'Ieškau žmogaus, su kuriuo derėtų ir ambicijos, ir paprastas, šiltas artumas.',
      },
    },
    // ── IV Sfera: Finansai ir resursai — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Kai tvarkau pinigus ir galvoju apie materialinę gerovę:',
      choices: {
        a: 'Pinigus valdau užtikrintai ir kryptingai, matau juos kaip laisvės ir galimybių įrankį.',
        b: 'Arba nuolat nerimauju, kad jų pritrūks, arba vaikausi jų taip, kad pamirštu visa kita.',
        c: 'Stengiuosi tvarkytis atsakingai, bet didelės rizikos ar ambicingų tikslų vengiu.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Kai priešais atsiveria galimybė užsidirbti ar investuoti daugiau:',
      choices: {
        a: 'Apgalvotai rizikuoju ir veikiu, nes tikiu savo gebėjimu kurti gausą.',
        b: 'Arba šoku į riziką godžiai ir neapdairiai, arba sustingstu iš baimės prarasti tai, ką turiu.',
        c: 'Renkuosi saugesnį, lėtesnį kelią, net jei jis atneša mažiau.',
      },
    },
    // ── V Sfera: Savirealizacija ir gyvenimo situacija — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Kai pasiekiu tikslą arba reikšmingą rezultatą:',
      choices: {
        a: 'Leidžiu sau pasidžiaugti pasiekimu, pripažįstu savo indėlį ir keliu naują, įkvepiantį tikslą.',
        b: 'Arba iškart vejuosi kitą tikslą, nepasidžiaugęs, arba nuvertinu tai, ką pasiekiau.',
        c: 'Trumpam stabteliu, bet greitai grįžtu prie kasdienių darbų, per daug nesureikšmindamas.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Kai galvoju apie savo gyvenimo užmojį ir potencialą:',
      choices: {
        a: 'Žinau, kad gebu sukurti ką nors didelio ir prasmingo, ir drąsiai einu to link.',
        b: 'Arba spaudžiu save be perstojo siekdamas vis daugiau, arba slopinu savo užmojus iš baimės.',
        c: 'Turiu siekių, bet juos saikingai ribuoju, kad išlaikyčiau ramybę ir saugumą.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Kai gyvenime ištinka nesėkmė ar prarandu tai, ką sukūriau:',
      choices: {
        a: 'Priimu tai kaip pamoką, atsitiesiu ir su nauja jėga pradedu kurti iš naujo.',
        b: 'Arba įnirtingai kovoju, kad atgaučiau kontrolę, arba palūžtu ir jaučiuosi visiškai bevertis.',
        c: 'Pergyvenu praradimą, bet pamažu atstatau tvarką ir judu pirmyn atsargesniais žingsniais.',
      },
    },
  ];

export default base8;
